import { render } from "./ContinueRegister.vue?vue&type=template&id=fe653fbe&scoped=true"
import script from "./ContinueRegister.vue?vue&type=script&lang=js"
export * from "./ContinueRegister.vue?vue&type=script&lang=js"

import "./ContinueRegister.vue?vue&type=style&index=0&id=fe653fbe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fe653fbe"

export default script